<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">产品</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">模板管理</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <el-button plain icon="el-icon-arrow-left" @click="$router.push('/domainMod')"></el-button>
        <span class="se-panel-title z-padding-left-5-precent ver-sub">新建模板</span>
      </div>
      <div class="panel-body clearfix">
        <div class="alert-warn">
          请认真填写以下信息，相关内容将会匹配至您的域名中。
        </div>
        <el-form :model="newForm" :rules="rules" ref="newForm" label-width="180px" class="domain-form" status-icon >
          <h4 class="template-floor">模板信息</h4>
          <el-form-item  label="模板名称：" :show-message="!formFocus.tname">
            <el-input v-model="newForm.tname" @focus="formFocus.tname = true" @blur="formFocus.tname = false" :disabled="true"></el-input>
            <!--<div class="icp-tip" v-show="formFocus.tname">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                模板名称，必填
              </div>
            </div>
            <br>
            <span class="z-font-size-12 z-color-999">如：域名XXX模板，仅方便查询用</span>-->
          </el-form-item>
          <el-form-item label="模板类型：" prop="company">
            <el-radio-group v-model="newForm.utype" size="small">
              <el-radio-button label="个人模板"></el-radio-button>
              <el-radio-button label="企业模板"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-show="newForm.utype === '个人模板'" label="域名所有人：" prop="uname" :show-message="!formFocus.uname">
            <el-input v-model="newForm.uname" @focus="formFocus.uname = true" @blur="formFocus.uname = false"></el-input>
            <div class="icp-tip" v-show="formFocus.uname">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                必须含有中文，特殊字符允许输入 .,、《》() -"“”&/'·及空格，最多可输入64字符
              </div>
            </div>
            <br>
            <span class="z-font-size-12 z-color-999">请输入个人姓名</span>
          </el-form-item>
          <el-form-item v-show="newForm.utype === '企业模板'" label="企业名称：" prop="uname" :show-message="!formFocus.uname">
            <el-input v-model="newForm.uname" @focus="formFocus.uname = true" @blur="formFocus.uname = false"></el-input>
            <div class="icp-tip" v-show="formFocus.uname">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                必须含有中文，特殊字符允许输入 .,、《》() -"“”&/'·及空格，最多可输入64字符
              </div>
            </div>
            <br>
            <span class="z-font-size-12 z-color-999">请输入企业名称</span>
          </el-form-item>
          <el-form-item label="域名联系人姓名：" prop="r_user_name_cn" :show-message="!formFocus.r_user_name_cn">
            <el-input v-model="newForm.r_user_name_cn" @focus="formFocus.r_user_name_cn = true" @blur="formFocus.r_user_name_cn = false"></el-input>
            <div class="icp-tip" v-show="formFocus.r_user_name_cn">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                必须含有中文，特殊字符允许输入 .,、《》() -"“”&/'·及空格，最多可输入64字符
              </div>
            </div>
          </el-form-item>
          <el-form-item label="电子邮箱：" prop="uemail" :show-message="!formFocus.uemail">
            <el-input v-model="newForm.uemail" @focus="formFocus.uemail = true" @blur="formFocus.uemail = false"></el-input>
            <div class="icp-tip" v-show="formFocus.uemail">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                最长不能超过 63 字符,必须包含“@”“.”，且不能为开头或结尾
              </div>
            </div>
          </el-form-item>
          <el-form-item label="电话：">
            <el-form :model="phoneForm" :rules="phonerules" ref="phoneForm" label-width="6px" class="phone-form" inline>
              <el-form-item label="" prop="utelc">
                <el-input v-model="phoneForm.utelc" class="phone-c"></el-input>
              </el-form-item>
              <el-form-item label="-" prop="utela">
                <el-input v-model="phoneForm.utela" class="phone-a"></el-input>
              </el-form-item>
              <el-form-item label="-" prop="uteln">
                <el-input v-model="phoneForm.uteln" class="phone-n"></el-input>
              </el-form-item>
            </el-form>
            <span class="z-font-size-12 z-color-999">固定电话依次举例：86 010 58022233；手机依次举例：86 138 58022233</span>
          </el-form-item>
          <el-form-item label="所属区域：" prop="is_open">
            <xdomain-city :province="cityInfo['province']" :city="cityInfo['city']" :area="cityInfo['area']" :DISTRICTS="DISTRICTS" v-model="cityInfo" v-loading="listLoading"></xdomain-city>
          </el-form-item>
          <el-form-item label="联系地址：" prop="street_cn" :show-message="!formFocus.street_cn">
            <el-input v-model="newForm.street_cn" @focus="formFocus.street_cn = true" @blur="formFocus.street_cn = false"></el-input>
            <div class="icp-tip" v-show="formFocus.street_cn">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                必须含有中文，特殊字符允许输入 .,、《》() -"“”&/'·及空格，最多可输入64字符
              </div>
            </div>
            <br>
            <span class="z-font-size-12 z-color-999">请填写详细地址</span>
          </el-form-item>
          <el-form-item label="邮编：" prop="r_zip" :show-message="!formFocus.r_zip">
            <el-input v-model="newForm.r_zip" @focus="formFocus.r_zip = true" @blur="formFocus.r_zip = false"></el-input>
            <div class="icp-tip" v-show="formFocus.r_zip">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                注册人邮政编码，必填
              </div>
            </div>
          </el-form-item>
          <h4 class="template-floor">模板信息</h4>
          <el-form-item label="域名所有人（英文）：" prop="organize_name_uk" :show-message="!formFocus.organize_name_uk">
            <el-input v-model="newForm.organize_name_uk" @focus="formFocus.organize_name_uk = true" @blur="formFocus.organize_name_uk = false" :disabled="true"></el-input>
            <div class="icp-tip" v-show="formFocus.organize_name_uk">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                必须含有英文，只允许输入特殊字符（.,、·（）()-""“”/\'），最多可输入64字符
              </div>
            </div>
          </el-form-item>
          <el-form-item label="域名联系人姓名（英文）：" prop="state">
            <el-form :model="nameForm" :rules="namerules" ref="nameForm" label-width="6px" class="name-form" inline>
              <el-form-item label="" prop="firstname">
                <el-input v-model="nameForm.firstname" class="zj-small-input"></el-input>
              </el-form-item>
              <el-form-item label="-" prop="lastname">
                <el-input v-model="nameForm.lastname" class="zj-small-input"></el-input>
              </el-form-item>
            </el-form>
          </el-form-item>
          <el-form-item label="省份（英文）：" prop="state">
            <el-input v-model="newForm.province_uk" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="城市（英文）：" prop="state">
            <el-input v-model="newForm.city_uk" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="通讯地址（英文）：" prop="street_uk" :show-message="!formFocus.street_uk">
            <el-input v-model="newForm.street_uk" @focus="formFocus.street_uk = true" @blur="formFocus.street_uk = false"></el-input>
            <div class="icp-tip" v-show="formFocus.street_uk">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                必须含有英文，特殊字符允许输入 .,、() -"“”&/'及空格符，最多可输入64字符
              </div>
            </div>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="submitForm('newForm','phoneForm','nameForm')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import XdomainCity from 'components/commons/XdomainCity.vue'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import domainService from 'business/domainService.js'
  import {ConvertPinyin} from 'utils/Pinyin'
  import {ConvertPinyinXiao} from 'utils/Pinyin'
  import {checkAreaCode,checkAreaCodeFax,IsEmail} from 'utils/areaCodeValidate'
  export default {
    data () {
      var checkAreaCodeLength = (rule, value, callback) => {
        if(!checkAreaCode(value)){
          return callback(new Error('输入的国家区号不存在'));
        }else {
          callback();
        }
      };
      var checkEmailLength = (rule, value, callback) => {
        if(!IsEmail(value)){
          return callback(new Error('邮箱格式错误，请重新输入！'));
        }else {
          callback();
        }
      };
      return {
        modList:[],
        listLoading:false,
        dialogLoading:false,
        DISTRICTS:[],
        cityInfo: {
          province:'中国',
          city:'北京市',
          area:'北京市'
        },
        newForm:{
          tname:'',
          utype:'个人模板',
          uname:'',
          r_user_name_cn:'',
          uemail:'',
          street_cn:'',
          r_zip:'',
          organize_name_uk:'',
          country_uk:'',
          province_uk:'beijingshi',
          city_uk:'shixiaqu',
          street_uk:'',
        },
        phoneForm:{
          utelc:'86',
          utela:'',
          uteln:'',
        },
        phoneForm2:{
          utelc:'86',
          utela:'',
          uteln:'',
        },
        nameForm:{
          firstname:'',
          lastname:'',
        },
        nameForm2:{
          firstname:'',
          lastname:'',
        },
        namerules:{
          firstname: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { pattern: /.*[a-zA-Z]+.*$/, message: '只允许输入英文、数字,且必须含有英文' },
            { pattern: /^[a-z0-9A-Z-(.,、)/\\ （）&'"·\“\”]+$/, message: '特殊字符允许输入 .,、() -"“”&/\'及空格符' },
            { max: 25, message: '输入字符个数不能大于64'}
          ],
          lastname: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { pattern: /.*[a-zA-Z]+.*$/, message: '只允许输入英文、数字,且必须含有英文' },
            { pattern: /^[a-z0-9A-Z-(.,、)/\\ （）&'"·\“\”]+$/, message: '特殊字符允许输入 .,、() -"“”&/\'及空格符' },
            { max: 25, message: '输入字符个数不能大于64'}
          ]
        },
        phonerules:{
          utelc: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { validator: checkAreaCodeLength , trigger: 'blur' }
          ],
          utela: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { pattern: /^([0-9])*$/, message: '请填写3-4位数字' },
            { min: 3, max: 4, message: '请填写3-4位数字'}
          ],
          uteln: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { pattern: /^([0-9])*$/, message: '请填写3-4位数字' },
            { min: 7, max: 8, message: '请填写7-8位数字'}
          ],
        },
        rules: {
          tname: [
            { required: true, message: '该项必填', trigger: 'blur' }
          ],
          uname: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { pattern: /.*[\u4e00-\u9fa5]+.*$/, message: '只允许输入中文、英文、数字,且必须含有中文' },
            { pattern: /^[a-z0-9A-Z\u4e00-\u9fa5-(.,、)/\\ 《》（）&'"·\“\”]+$/, message: '特殊字符允许输入 .,、《》() -"“”&/\'·及空格' },
            { max: 64, message: '输入字符个数不能大于64'}
          ],
          r_user_name_cn: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { pattern: /.*[\u4e00-\u9fa5]+.*$/, message: '只允许输入中文、英文、数字,且必须含有中文' },
            { pattern: /^[a-z0-9A-Z\u4e00-\u9fa5-(.,、)/\\ 《》（）&'"·\“\”]+$/, message: '特殊字符允许输入 .,、《》() -"“”&/\'·及空格' },
            { max: 64, message: '输入字符个数不能大于64'}
          ],
          uemail: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { validator: checkEmailLength , trigger: 'blur' },
            { max: 63, message: '输入字符个数不能大于63位'}
          ],
          street_cn: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { pattern: /.*[\u4e00-\u9fa5]+.*$/, message: '只允许输入中文、英文、数字,且必须含有中文' },
            { pattern: /^[a-z0-9A-Z\u4e00-\u9fa5-(.,、)/\\ 《》（）&'"·\“\”]+$/, message: '特殊字符允许输入 .,、《》() -"“”&/\'·及空格' },
            { max: 64, message: '输入字符个数不能大于64'}
          ],
          r_zip: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { pattern: /^([0-9])*$/ , message: '邮编限6~10位数字' },
            { min: 6, message: '输入字符个数不能小于6'},
            { max: 10, message: '输入字符个数不能大于10'},
          ],
          organize_name_uk: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { pattern: /.*[a-zA-Z]+.*$/, message: '只允许输入英文、数字,且必须含有英文' },
            { pattern: /^[a-z0-9A-Z-(.,、)/\\ （）&'"·\“\”]+$/, message: '特殊字符允许输入 .,、() -"“”&/\'及空格符' },
            /*{ max: 64, message: '输入字符个数不能大于64'}*/
          ],
          street_uk: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { pattern: /.*[a-zA-Z]+.*$/, message: '只允许输入英文、数字,且必须含有英文' },
            { pattern: /^[a-z0-9A-Z-(.,、)/\\ （）&'"·\“\”]+$/, message: '特殊字符允许输入 .,、() -"“”&/\'及空格符' },
            { max: 64, message: '输入字符个数不能大于64'}
          ],
        },
        formFocus: {
          tname:false,
          uname:false,
          r_user_name_cn:false,
          uemail:false,
          street_cn:false,
          r_zip:false,
          organize_name_uk:false,
          street_uk:false,
        },
      }
    },
    components:{
      XdomainCity,
      XdialogLoading
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.getArea()
    },
    computed: {
      city() {
        return this.cityInfo.city
      },
      area() {
        return this.cityInfo.area
      },
      uname() {
        return this.newForm.uname
      },
      r_user_name_cn() {
        return this.newForm.r_user_name_cn
      },
      street_cn() {
        return this.newForm.street_cn
      },
    },
    watch:{
      city(){
        for(let i in this.DISTRICTS){
          if(this.DISTRICTS[i].area_cn == this.cityInfo.province){
            this.newForm.country_uk = this.DISTRICTS[i].area_en
            let province = this.DISTRICTS[i].province
            for(let j in province){
              if(province[j].area_cn == this.cityInfo.city){
                this.newForm.province_uk = province[j].area_en
                let city = province[j].city
                for(let k in city){
                  if(city[k].area_cn == this.cityInfo.area){
                    this.newForm.city_uk = city[k].area_en
                  }
                }
              }
            }
          }
        }
      },
      area(){
        for(let i in this.DISTRICTS){
          if(this.DISTRICTS[i].area_cn == this.cityInfo.province){
            this.newForm.country_uk = this.DISTRICTS[i].area_en
            let province = this.DISTRICTS[i].province
            for(let j in province){
              if(province[j].area_cn == this.cityInfo.city){
                this.newForm.province_uk = province[j].area_en
                let city = province[j].city
                for(let k in city){
                  if(city[k].area_cn == this.cityInfo.area){
                    this.newForm.city_uk = city[k].area_en
                  }
                }
              }
            }
          }
        }
      },
      uname(val,oldval){
        this.newForm.organize_name_uk = ConvertPinyinXiao(val)
        this.newForm.tname = val
      },
      r_user_name_cn(val,oldval){
        this.nameForm.firstname = ConvertPinyin(val).substr(0,ConvertPinyin(val).indexOf(' '))
        this.nameForm.lastname = ConvertPinyin(val).substr(ConvertPinyin(val).indexOf(' ')+1)
      },
      street_cn(val,oldval){
        this.newForm.street_uk = ConvertPinyinXiao(val)
      },
    },
    methods:{
      async submitForm(formName,secondForm,threeForm) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$refs[secondForm].validate((valid) => {
              if (valid) {
                this.$refs[threeForm].validate((valid) => {
                  if (valid) {
                    this.submit()
                  } else {
                    return false;
                  }
                });
              } else {
                return false;
              }
            });
          } else {
            return false;
          }
        });
      },
      async getArea() {
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST','cmd=area_dic')
        if(state.code === '000' ) {
          this.DISTRICTS = vueData
        }else {
          this.$toast('请刷新页面...','fail')
        }
      },
      async submit() {
        this.dialogLoading = true
        let utype = this.newForm.utype === '个人模板' ? 'P' : 'C'
        let data = 'cmd=mod_add'+
          '&tname='+ this.newForm.tname +
          '&utype='+ utype +
          '&uname1='+ this.newForm.uname +
          '&uname2=' + this.newForm.organize_name_uk.substr(0,64) +
          '&rname1=' + this.newForm.r_user_name_cn +
          '&rname2=' + this.nameForm.firstname +
          '&rname3=' + this.nameForm.lastname +
          '&uprov=' + this.newForm.province_uk +
          '&ucity2=' + this.newForm.city_uk +
          '&uaddr1=' + this.newForm.street_cn +
          '&uaddr2=' + this.newForm.street_uk +
          '&uzip=' + this.newForm.r_zip +
          '&utelc=' + this.phoneForm.utelc +
          '&utela=' + this.phoneForm.utela +
          '&uteln=' + this.phoneForm.uteln +
          '&uemail=' + this.newForm.uemail
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.$router.push('/domainMod')}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
  }
  .hideleft { margin-left: 80px; }
  .domain-form .el-input,.el-select {
    width: 440px;
  }
  .domain-form .zj-small-input.el-input{
    width: 143px;
  }
  .input-with-select .el-input-group__prepend .el-select {
    width: 90px;
  }
  .alert-warn {
    margin-bottom: 20px;
  }
  .template-floor {
    margin: 27px 0 27px;
    font-weight: bold;
    font-size: 14px;
    color: #00aaff;
  }
  .domain-form .phone-c.el-input{
    width: 84px;
  }
  .domain-form .phone-a.el-input{
    width: 84px;
  }
  .domain-form .phone-n.el-input{
    width: 243px;
  }
  .renzheng-form .el-input,.el-select {
    width: 440px;
  }

  .icp-msg {
    color: #4074e1;
    border: solid 1px #4074e1;
    background: #ecf1fc;
    border-radius: 3px;
    position: relative;
    margin-top: 10px;
    font-size: 12px;
    line-height: 18px;
    padding: 10px;
    width: 352px;
  }
  em{
    font-style: normal;
    font-weight: 500;
  }
  .icp-tip {
    position: absolute;
    left: 441px;
    top: 0;
    margin-left: 10px;
    width: 400px;
    line-height: 32px;
    font-size: 12px;
  }
  .icp-tip .icp-msg {
    margin: 0 0 0 30px;
    padding: 6px 10px;
    width: 300px;
  }
  .icp-tip span {
    padding-left: 6px;
  }
  .hoticon-left {
    position: absolute;
    top: 12px;
    left: -4px;
    background: url(../../assets/imgs/hoticon.png) no-repeat;
    background-position: 0 -5px;
    width: 4px;
    height: 6px;
  }
  .icon-i {
    color: #4074e1;
    padding-left: 5px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/product/domainAddMod.vue